import React from "react";
import { Link } from "react-router-dom";
import LoginModal from "./LoginModal";
import PdfModal from "./PdfModal";
import PdfModalAll from "./PdfModal_all";
import VideoModal from "./VideoModal";
import TrainerRegistration from "./TrainerRegistration";
import StudentModal from "./StudentModal";
const Header = ({triggerGrandchildRefresh }) => {
  return (
    <section>
        <LoginModal />
        <PdfModal triggerGrandchildRefresh ={triggerGrandchildRefresh }/>
        <VideoModal triggerGrandchildRefresh ={triggerGrandchildRefresh }/>
        <TrainerRegistration />
        <StudentModal />
         <PdfModalAll triggerGrandchildRefresh ={triggerGrandchildRefresh }/>
               
    </section>
  );
};

export default Header;